import React from 'react';
import HeadingButtonBase from './HeadingButtonBase';

function HeadingThreeButton() {
  return <HeadingButtonBase format="heading_three" title="H3" />;
}

export default HeadingThreeButton;
